if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.initSwipeListener()

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', () => {
          this.setActiveMedia(mediaToSwitch.dataset.target)
        });
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    initSwipeListener() {
      const isDesktopLayout = this.mql.matches;
      const isTouchDevice = 'ontouchstart' in document.documentElement;
      if (isDesktopLayout) return;
      this.elements.viewerSlider = this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
      const sliderItems = this.elements.viewer.querySelectorAll('[id^="Slide-template"]');
      this.sliderItemsToShow = Array.from(sliderItems).filter(element => element.clientWidth > 0);
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      const thumbnailItems = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item');
      this.thumbnailOffset = thumbnailItems[1].offsetLeft - thumbnailItems[0].offsetLeft;
      this.currentPage = Math.round(this.elements.viewerSlider.scrollLeft / this.sliderItemOffset) + 1;
      if (isTouchDevice) {
        this.elements.viewer.addEventListener('touchmove', this.onSwipe.bind(this));
        this.elements.viewer.addEventListener('touchend', this.onSwipeEnd.bind(this));
      } else {
        this.elements.viewer.addEventListener('wheel', this.onSwipe.bind(this));
      }
    }

    onSwipeEnd() {
      // stop scroll momentum
      this.elements.viewerSlider.style.overflow = 'hidden';
      setTimeout(() => {
        // snap to position
        this.elements.viewerSlider.scrollTo({
          left: this.sliderItemsToShow[this.currentPage - 1].offsetLeft,
          behavior: 'smooth'
        });
        // restore scrollability
        this.elements.viewerSlider.style.overflow = 'auto';
      }, 10);
    }

    onSwipe() {
      this.setViewerTransition(false);
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.elements.viewerSlider.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPage != previousPage) {
        this.elements.viewer.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }
    }

    onSlideChanged(event) {
      const mediaId = event.detail.currentElement.dataset.mediaId;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`); 
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
      this.setViewerTransition(true);
    }

    setActiveMedia(mediaId, options = { setActiveThumbnailCentered: true }) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);    
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail, options);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail, options = { setActiveThumbnailCentered: true }) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element, index) => {
        if (element.parentElement.isEqualNode(thumbnail)) {
          this.currentPage = index + 1;
          element.setAttribute('aria-current', true);
        } else {
          element.removeAttribute('aria-current');
        }
      });

      let top = thumbnail.offsetTop;
      let left = thumbnail.offsetLeft;

      const isDesktopLayout = this.mql.matches;
      if (isDesktopLayout) {
        this.elements.thumbnails.slider.scrollTo({ top });
      } else {
        if (options.setActiveThumbnailCentered) {
          if (this.currentPage > 2 && this.currentPage + 2 < this.sliderItemsToShow.length) {
            left -= this.thumbnailOffset * 2;
          }
        }
        this.elements.thumbnails.slider.scrollTo({ left });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (image) {
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
            '[index]',
            position
            );
            setTimeout(() => {
              this.elements.liveRegion.setAttribute('aria-hidden', true);
            }, 2000);
          };
          image.src = image.src;
          setTimeout(() => {
            activeItem.classList.add('is-active');
          }, 300);
      } else {
        const videoModalOpener = activeItem.querySelector('.product__modal-opener--video');
        if (videoModalOpener) {
          const isDesktopLayout = this.mql.matches;
          if (isDesktopLayout) {
            activeItem.classList.add('is-active');
          } else {
            videoModalOpener.querySelector('img').classList.remove('fade-transition');
          }
        }
      }
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    setViewerTransition(active) {
      if (active) {
        this.elements.viewer.querySelectorAll('.product__media-item .product__media img').forEach(img => {
          img.classList.add('fade-transition');
        });
      } else {
        this.elements.viewer.querySelectorAll('.product__media-item .product__media img').forEach(img => {
          img.classList.remove('fade-transition');
        });
      }
    }
  });
}
